import { Delete as DeleteIcon, Payment as PaymentIcon, StarBorder as StarBorderIcon, Star as StarIcon } from '@mui/icons-material'
import { Box, Container, Dialog, IconButton, LinearProgress, List, ListItem, ListItemSecondaryAction, ListItemText, Tooltip, Typography } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import React from 'react'
import Heading from '../components/Heading'
import { withAppContext } from '../context/AppContextProvider'

const styles = (theme) => ({
    loading: {
        marginTop: theme.spacing(2),
    },
    listItemText: {
        paddingRight: 78,
    },
    marginAbove: {
        marginTop: theme.spacing(2),
    },
})

class PaymentMethods extends React.Component {
    state = {
        waits: 1,
        saving: false,
        cardsOnFile: [],
    }

    async componentDidMount() {
        await this.getCards()

        await this.setState({
            waits: this.state.waits - 1,
        })
    }

    getCards = async () => {
        await this.setState({
            waits: this.state.waits + 1,
        })

        try {
            const cardsOnFile = await this.props.socket.send('paymentMethods', {
                step: 'getCards',
            })

            await this.setState({
                cardsOnFile,
            })

        } catch (err) {
            this.props.showError(err)
        }

        await this.setState({
            waits: this.state.waits - 1,
        })
    }

    handleChooseCard = async (cardId) => {
        await this.setState({
            saving: true,
        })

        try {
            const response = await this.props.socket.send('paymentMethods', {
                step: 'chooseCard',
                cardId,
            })

            this.props.showMessage(response, {
                autoHideDuration: 3000,
            })

        } catch (err) {
            this.props.showError(err)
        }

        await this.getCards()

        await this.setState({
            saving: false,
        })
    }

    handleRemoveCard = async (cardId) => {
        await this.setState({
            saving: true,
        })

        try {
            const response = await this.props.socket.send('paymentMethods', {
                step: 'removeCard',
                cardId,
            })

            this.props.showMessage(response, {
                autoHideDuration: 3000,
            })

        } catch (err) {
            this.props.showError(err)
        }

        await this.getCards()

        await this.setState({
            saving: false,
        })
    }

    render() {
        const { classes } = this.props
        const { cardsOnFile, waits, saving } = this.state

        return (
            <Container maxWidth="sm">
                <Heading icon={<PaymentIcon />}>
                    Payment Methods
                </Heading>
                {waits > 0 &&
                    <LinearProgress className={classes.loading} />
                }
                {waits == 0 &&
                    <>
                        <List>
                            {cardsOnFile.map((card) =>
                                <ListItem key={card.id}>
                                    <ListItemText
                                        className={classes.listItemText}
                                        primary={card.card_type || 'Credit Card'}
                                        secondary={`${card.card_holder} ${card.card_number} / ${card.expiry_date}`}
                                    />
                                    <ListItemSecondaryAction>
                                        {card.is_active == 1 &&
                                            <Tooltip disableInteractive arrow title="Default payment method">
                                                <IconButton
                                                    edge="end"
                                                    aria-label="default-payment-method"
                                                    onClick={() => this.handleChooseCard(card.id)}
                                                    size="large"
                                                >
                                                    <StarIcon />
                                                </IconButton>
                                            </Tooltip>
                                        }
                                        {card.is_active != 1 &&
                                            <Tooltip disableInteractive arrow title="Set as default payment method">
                                                <IconButton
                                                    edge="end"
                                                    aria-label="set-default-payment-method"
                                                    onClick={() => this.handleChooseCard(card.id)}
                                                    size="large"
                                                >
                                                    <StarBorderIcon />
                                                </IconButton>
                                            </Tooltip>
                                        }
                                        <Tooltip disableInteractive arrow title="Remove payment method">
                                            <IconButton
                                                edge="end"
                                                aria-label="delete"
                                                onClick={() => this.handleRemoveCard(card.id)}
                                                size="large"
                                            >
                                                <DeleteIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </ListItemSecondaryAction>
                                </ListItem>
                            )}
                        </List>
                        {!cardsOnFile.length &&
                            <Box className={classes.box}>
                                <Typography>You have no payment methods saved on file. You can save one during your next order.</Typography>
                            </Box>
                        }
                        <Dialog open={saving}>
                            <Typography className={classes.dialogText}>Saving, please wait...</Typography>
                        </Dialog>
                    </>
                }
            </Container>
        )
    }
}

export default withAppContext(withStyles(styles, { withTheme: true })(PaymentMethods))
